import { useEffect } from "react";

/** Tool names the AI agent can call that mutate a note page/folder. */
export const AI_NOTE_TOOLS = new Set([
  "create_note_page",
  "create_note_folder",
  "update_note_page",
  "edit_note_page",
  "move_note_page",
  "delete_note_page",
]);

export const AI_NOTE_CHANGED_EVENT = "ai-note-changed";

export interface NoteChangedDetail {
  tool: string;
  id?: string;
  parentId?: string | null;
  [key: string]: unknown;
}

/**
 * Notifies open Notes/Wiki views when the AI agent creates, edits, moves, or
 * deletes a page/folder — those changes bypass this page's own fetch calls,
 * so without this listener the UI only reflects them after a manual refresh.
 */
export function useNoteChangeListener(onChanged: (detail: NoteChangedDetail) => void) {
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<NoteChangedDetail>).detail;
      if (detail) onChanged(detail);
    };
    window.addEventListener(AI_NOTE_CHANGED_EVENT, handler);
    return () => window.removeEventListener(AI_NOTE_CHANGED_EVENT, handler);
  }, [onChanged]);
}
